import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
export default {
name: 'homePage',
directives: {
TransferDom
},
components: {
Swiper,
SwiperItem,
Divider,
XImg, Popup,
videoPlayer
},
data () {
return {

isVideo:false,
isautoplay:true,
isVouchers:false,
src:'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/vedio/2021/1222/AfT4KrSs85.mp4',
videoList:[
{
id:'1',

img:require('../../assets/images/霸王龙头骨.png'),
src:'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/vedio/2021/1222/AfT4KrSs85.mp4'
},
{
id:'2',

img:require('../../assets/images/3d打印黑色材料.png'),
src:'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/vedio/2021/1222/kdmZ4DmmmW.mp4'
},
{
id:'3',

img:require('../../assets/images/3d打印透明材料.png'),
src:'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/vedio/2021/1222/6Cr5RJYFzJ.mp4'
},
{
id:'4',

img:require('../../assets/images/小龙虾.png'),
src:'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/vedio/2021/1222/6FdBtfa55r.mp4'
},
{
id:'5',

img:require('../../assets/images/3d打印透明pc.png'),
src:'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/vedio/2021/1222/yA6kfGwXFQ.mp4'
},
{
id:'6',

img:require('../../assets/images/3d打印塔.png'),
src:'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/vedio/2021/1222/SK3jiC4EhB.mp4'
},

{
id:'7',

img:require('../../assets/images/骷髅.png'),
src:'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/vedio/2021/1222/jk2mQjFKB5.mp4'
},
{
id:'8',

img:require('../../assets/images/小熊台灯.png'),
src:'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/vedio/2021/1222/CaG8mnme5h.mp4'
},
{
id:'9',

img:require('../../assets/images/小鱼干.png'),
src:'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/vedio/2021/1222/x2BZmSW3HT.mp4'
},


],
topSwiperList: [

{
src: require('../../assets/images/homebanner1.png'),
href: '/print',
},
{
src: require('../../assets/images/homebanner2.png'),
href: '/print',
},

{
src: require('../../assets/images/homebanner3.png'),
href: '/customization',
},



















],
productsList: [],
newsList: [],
discountData: [],
videoShow:false,
videoPath:'',
bigVideoPath:'',
videoMask:false,
videoImgPath:'',
palyBtn:true,
shopActive:'equalRatio',
industryType:'aerospace',
advertising:true,
widthVideo:'',
videoSrcc0:'',//綫上
videoSrcc1:'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/vedio/star/qsy.mp4' ,//工厂
videoSrccList:[  //视频列表
'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/vedio/star/qsy.mp4',
'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/vedio/star/zhanghehe-qsy.mp4',
'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/vedio/star/nawei-qsy.mp4',
'https://hlh-shopping.oss-cn-shenzhen.aliyuncs.com/vedio/star/wushuang-qsy.mp4',
],
videoSrccList1:[],  //顺序处理
indexId:0,//
berTime:1661356800000,  //  2022-08-25 00:00:00

}
},



methods: {





supportfull(){
var requestFullscreen =
document.body.requestFullscreen ||
document.body.webkitRequestFullscreen ||
document.body.mozRequestFullScreen ||
document.body.msRequestFullscreen;
var fullscreenEnabled =
document.fullscreenEnabled ||
document.mozFullScreenEnabled ||
document.webkitFullscreenEnabled ||
document.msFullscreenEnabled;
return !!(requestFullscreen && fullscreenEnabled);
},

isVideoT(){
this.isVideo=false
},
isVideoC(item){
console.log('item',item.src)
this.src=item.src
this.name=item.name


this.isVideo=true


},
close(){
this.isVouchers=false
sessionStorage.setItem('loginsum', '2')
},
use(){
sessionStorage.setItem('loginsum', '2')
this.$router.push({
path: '/print'
})
},
setinit(){
var sum=sessionStorage.getItem('sum')
console.log('sum',sum);
if(sum==null){

sessionStorage.setItem('sum', '1')
this.$router.push({
path: '/activity'
})
}
var loginsum=sessionStorage.getItem('loginsum')
var that=this
if(loginsum=='1'){

setTimeout(function(){
that.isVouchers=true
},1000)

}



},
setCookie(cname, cvalue, exdays) {



var d = new Date();
d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
var expires = "expires=" + d.toUTCString();
document.cookie = cname + "=" + cvalue + "; " + expires+"; path=/"   
console.log(d)
},
getCookie(name) {
var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
if (arr = document.cookie.match(reg))
return unescape(arr[2]);
else
return null;
},
getNewsList () {
this.$request.post('/news/listNews',{
categoryId: ''
}).then(data => {
if(data.code == 0){
for(let i=0; i<2; i++){
this.newsList.push(data.obj[i])
}

}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
})
},
gotoNewsInfo(item){
this.$router.push({
path:'./newsDetail',
query:{
id:item.id
}
})
},
getVoucher () {
this.$request.post('/couponDetail/getCouponBasicInfo',{

}).then(data => {
if(data.code == 0){
var arr = data.obj[0].activityContent.split('。')
arr.forEach((item, index) => {
if(this.$trim(item) != ''){
var obj = {}
obj.str = item
obj.click = true
this.discountData.push(obj)
}
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
topSwiperClickEvent (item, index) {
this.$router.push({
path: item.href
})
},
getVideo(){




let dwc=24*3600*1000  
let  NewTime=new Date().getTime()




console.log('当前',NewTime);
console.log('定点',this.berTime);

console.log('时间差',NewTime-this.berTime);
console.log('(NewTime-this.berTime)/dwc',(NewTime-this.berTime)/dwc);
console.log('(NewTime-this.berTime)/dwc',(NewTime-this.berTime)%dwc);




let Tsum=  parseInt((NewTime-this.berTime)/dwc)
if((NewTime-this.berTime)%dwc!=0){
Tsum=Tsum+1
}



console.log('Tsum天数',Tsum);




let ksindex=Tsum%this.videoSrccList.length

console.log( '开始位置',ksindex);

this.videoSrccList1=[]

for(let i=0;i<this.videoSrccList.length;i++){



if(ksindex<this.videoSrccList.length){
this.videoSrccList1.push(this.videoSrccList[ksindex])
ksindex++

}else{
ksindex=0
this.videoSrccList1.push(this.videoSrccList[ksindex])
}

}


this.videoPath= this.videoSrccList1[this.indexId]


console.log(' this.videoSrccList1', this.videoSrccList1);











if(this.getCookie('videoStop')!='0'){
this.videoShow = true
}


},













palyVideo(){
console.log(this.$refs.video);
this.$refs.video.play();
this.videoMask = true
this.videoShow = false
this.bigVideoPath = this.videoPath
},
stopVideo(){
this.$refs.video.pause();
this.$refs.smallvideo.pause();
this.videoMask = false
this.videoShow = true
},
closeVideo(){
this.videoShow = false
this.setCookie('videoStop', '0', 0.288)

this.$refs.video.pause();
this.$refs.smallvideo.pause();
this.videoMask = false
this.videoShow = false
},
closeAdvertising(){
this.$router.push({
path: '/generalize'
})
}
},
created () {












this.widthVideo='100%'
this.getNewsList()
this.getVoucher()

if(!!this.$route.query.inviteCode){
this.setCookie('_mobileInviteCode', this.$route.query.inviteCode, 0.288);
}
this.getVideo()






},
mounted() {



















document.getElementById('smallvideo1').addEventListener( "ended", () => {
console.log('xxxx');


if(this.videoSrccList1.length>this.indexId+1){
this.indexId++

}else{
this.indexId=0
}


this.videoPath=this.videoSrccList1[this.indexId]






}, false );
}

}



// WEBPACK FOOTER //
// ./src/views/homePage/script.js